<template>
    <tr class="row-odd row-one-line">
        <td class="td-padding">
            <input
                type="checkbox"
                value=""
                @click="selectDocument(due.payment.id)"
                :checked="selected"
            />
        </td>
        <td class="td-padding">{{ due.document.translated_document_type }}</td>
        <td class="td-padding">
            <truncated-text :text="due.document.document_number" :max_length="20"/>
        </td>
        <td class="td-padding text-wrap contractor-name">
            <truncated-text v-if="due.contractor" :text="due.contractor.name" :max_length="100"/>
            <template v-else>-</template>
        </td>
        <td class="td-padding">{{ due.document.date_issued }}</td>
        <td class="td-padding text-right">
            {{ due.payment.payment_amount | localizeMoney }}
        </td>
        <td class="td-padding">
            {{
                due.payment.payment_currency
                    ? due.payment.payment_currency
                    : due.document.currency
            }}
        </td>
        <td class="td-padding text-right">{{ due.document.document_exchange_rate_presentation }}</td>
        <td class="td-padding text-right">
            {{
                amount_due_in_base_currency(
                    due.payment.payment_amount,
                    due.document.exchange_rate == 1 ? '-' : due.document.exchange_rate
                ) | localizeMoney
            }}
        </td>
        <td class="td-padding">{{ due.payment.payment_due_date }}</td>
        <td class="td-padding text-right">{{ due.days_late }}</td>
        <td class="text-right table-icons">
            <a
                class="tooltip-more"
                data-toggle="tooltip"
                data-placement="top"
                :data-original-title="__('download_file')"
                :href="`${documentScanRoute}/${due.document.document_id}`"
                v-if="due.document_scan && permission_access['perm_route_records.documents.scan'] == true"
            >
                <i class="fas fa-paperclip"></i>
            </a>
            <a
                class="tooltip-more"
                data-toggle="tooltip"
                data-placement="top"
                :data-original-title="__('download_file')"
                :href="`${documentPdfRoute}/${due.document.document_id}`"
                v-if="due.document.pdf_url && permission_access['perm_route_records.documents.pdf'] == true"
            >
                <i class="fas fa-paperclip"></i>
            </a>
            <a v-if="tab == 'receivables' ? due.document.has_access_show_receivables : due.document.has_access_show_liabilities"
                :href="
                    `${previewRoute}/${
                        due.document.document_id
                    }/?return=${getReturnURLParametrs()}`
                "
                onclick="event.stopPropagation()"
                data-toggle="tooltip"
                data-placement="top"
                :data-original-title="__('show')"
            >
                <i class="fa fa-eye"></i>
            </a>
        </td>
    </tr>
</template>

<script>
import filters from './../../../services/Filters.js'
import permissions from './../../../services/Permissions.js'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'item-row',
    props: {
        due: {
            type: Object
        },
        tab: {
            type: String,
            default: '#'
        },
        documentScanRoute: {
            type: String,
            default: '#'
        },
        documentPdfRoute: {
            type: String,
            default: '#'
        },
        previewRoute: {
            type: String,
            default: '#'
        },
        previewReturnRoute: {
            type: String,
            default: '#'
        },
        permission_access: {
            default: null
        },
    },
    methods: {
        amount_due_in_base_currency(amount, exchaneRate) {
            if (exchaneRate == '-') {
                return amount
            } else {
                return (parseFloat(amount) * parseFloat(exchaneRate.replace(' ', '').replace(',', '.'))).toFixed(2)
            }
        },
        selectDocument(id) {
            if (event.target.checked) {
                this.addToSelected([id])
            } else if (!event.target.checked) {
                this.$emit('unselect')
                this.removeFromSelected(id)
            }
        },
        getReturnURLParametrs() {
            return encodeURIComponent(
                `${this.previewReturnRoute}/?date=${this.date}&currency=${this.currency}`
            )
        },
        ...mapActions(['addToSelected', 'removeFromSelected'])
    },
    computed: {
        selected() {
            return this.$store.getters.isSelectedDocument(this.due.payment.id)
        },
        addEditPermission() {
            if(this.due.document.is_document_pl) {
                return permissions.getPermission(this.permission_access, 'perm_route_records.documents.show-own')
            }
            return permissions.getPermission(this.permission_access, 'perm_route_records.documents.show-own')
        },
        ...mapGetters({
            currency: 'getCurrency',
            date: 'getDate'
        })
    },
    filters: filters
}
</script>
